// removed by extract-text-webpack-plugin
module.exports = {"input":"input-kMF8N","input-start":"input-start-1Ewqp","input-end":"input-end-AM_Xi","label":"label-3LEgu","label-search":"label-search-1Dynv","dash":"dash-1Lrxm","prefix":"prefix-1A671","prefix-search":"prefix-search-2oIvk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/search-form/style.scss
 ** module id = 25
 ** module chunks = 0
 **/